export const environment = {
  production: false,
  apiUrl: 'http://localhost:3000/data', // Your development API URL
  // Add other development-specific variables here
};